import API from "./API";

export const createNewUserAPI = (payload) => {
  return API.post(`/user-management/create-user`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const createNewRoleAPI = (payload) => {
  return API.post(`/user-management/create-new-role`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllAdminUsersAPI = (payload) => {
  return API.get(`/user-management/all-user?page=${payload?.page||0}&size=${payload?.size||10}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAdminUserAPI = (payload) => {
  return API.get(`/user-management/get-user-detail/${payload?.userId}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllAdminUserRolesAPI = (payload) => {
  return API.get(`/user-management/get-roles`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};